/**
 * Wraps an absolute file URL in the backend's own Next.js image-optimization
 * endpoint (`<origin>/_next/image?url=<encoded>&w=<width>&q=<quality>`),
 * serving a resized/compressed variant instead of the original — the admin
 * previously always fetched full-resolution originals for every avatar/cover
 * thumbnail, which was especially slow on list pages with many rows at once
 * (ticket: doctor profiles list). The proxy lives on the same origin as the
 * file itself, so no separate host constant is needed.
 *
 * A `private_files` URL is never wrapped: that endpoint's files require the
 * admin's own session auth to fetch, which the image-optimization proxy
 * doesn't have (and routing a private file through a public proxy would be
 * a privacy regression even if it did) — returned unchanged, same as before
 * this existed.
 */
export function optimizeImageUrl(url: string | null | undefined, width: number, quality = 75): string | undefined {
  if (!url) return url ?? undefined
  if (url.includes('private_files')) return url
  let origin: string
  try {
    origin = new URL(url).origin
  } catch {
    return url
  }
  return `${origin}/_next/image?url=${encodeURIComponent(url)}&w=${width}&q=${quality}`
}
